window.addEventListener("load", function () {
	var headerSection = document.getElementById("vxphl-ld-25-a-header");
	var startX = 0;
	var startY = 0;
	var swipeThreshold = 30;
	var isMouseDown = false;

	if (!headerSection) {
		return;
	}

	function isHeaderVisible() {
		var style = window.getComputedStyle(headerSection);
		return style.display !== "none" && headerSection.getClientRects().length > 0;
	}

	headerSection.addEventListener("touchstart", function (event) {
		if (!isHeaderVisible() || !event.touches || !event.touches.length) {
			return;
		}

		startX = event.touches[0].clientX;
		startY = event.touches[0].clientY;
	});

	headerSection.addEventListener("touchend", function (event) {
		var endX;
		var endY;
		var deltaX;
		var deltaY;

		if (!isHeaderVisible() || !event.changedTouches || !event.changedTouches.length) {
			return;
		}

		endX = event.changedTouches[0].clientX;
		endY = event.changedTouches[0].clientY;
		deltaX = endX - startX;
		deltaY = endY - startY;

		if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) <= Math.abs(deltaY)) {
			return;
		}

		if (deltaX > 0) {
			if (typeof window.slideRight === "function") {
				window.slideRight();
			}
		} else {
			if (typeof window.slideLeft === "function") {
				window.slideLeft();
			}
		}
	});

	headerSection.addEventListener("mousedown", function (event) {
		if (!isHeaderVisible()) {
			return;
		}

		isMouseDown = true;
		startX = event.clientX;
		startY = event.clientY;
	});

	headerSection.addEventListener("mouseup", function (event) {
		var endX;
		var endY;
		var deltaX;
		var deltaY;

		if (!isHeaderVisible() || !isMouseDown) {
			return;
		}

		isMouseDown = false;

		endX = event.clientX;
		endY = event.clientY;
		deltaX = endX - startX;
		deltaY = endY - startY;

		if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) <= Math.abs(deltaY)) {
			return;
		}

		if (deltaX > 0) {
			if (typeof window.slideRight === "function") {
				window.slideRight();
			}
		} else {
			if (typeof window.slideLeft === "function") {
				window.slideLeft();
			}
		}
	});

	headerSection.addEventListener("mouseleave", function () {
		isMouseDown = false;
	});
});
